/**
 * Sample Kit Flavour Picker
 * Lets customer pick exactly 3 cocktails (duplicates allowed).
 * Blocks add-to-cart until 3 are chosen.
 * Writes selections as line item properties.
 */

(function () {
  'use strict';

  var MAX = 3;
  var selections = []; // array of flavour strings

  var picker, grid, counter, countEl, errorEl;
  var prop1, prop2, prop3, propTags;
  var addToCartBtn;

  /* ── Helpers ──────────────────────────────────────────────── */

  function updateUI() {
    countEl.textContent = selections.length;

    // Update counter styling
    counter.classList.toggle('sk-counter--complete', selections.length === MAX);
    counter.classList.toggle('sk-counter--over', selections.length > MAX);

    // Update button badges & states
    var buttons = grid.querySelectorAll('.sk-flavour');
    buttons.forEach(function (btn) {
      var flavour = btn.getAttribute('data-flavour');
      var count = selections.filter(function (s) { return s === flavour; }).length;

      btn.setAttribute('aria-pressed', count > 0 ? 'true' : 'false');
      btn.classList.toggle('sk-flavour--selected', count > 0);

      var badge = btn.querySelector('.sk-flavour__badge');
      if (count > 1) {
        badge.textContent = 'x' + count;
        badge.style.display = '';
      } else if (count === 1) {
        badge.textContent = '';
        badge.style.display = '';
      } else {
        badge.textContent = '';
        badge.style.display = 'none';
      }
    });

    // Hidden properties
    prop1.value = selections[0] || '';
    prop2.value = selections[1] || '';
    prop3.value = selections[2] || '';

    // Build tags string: "Bloody Mary x2, Paloma"
    var tagCounts = {};
    selections.forEach(function (s) { tagCounts[s] = (tagCounts[s] || 0) + 1; });
    var tagParts = [];
    Object.keys(tagCounts).forEach(function (name) {
      tagParts.push(name + (tagCounts[name] > 1 ? ' x' + tagCounts[name] : ''));
    });
    propTags.value = tagParts.join(', ');

    // Sync to cart attributes so Flow can read them
    if (selections.length === MAX) {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: {
          'Sample Kit Cocktails': propTags.value,
          'Cocktail 1': selections[0] || '',
          'Cocktail 2': selections[1] || '',
          'Cocktail 3': selections[2] || ''
        }}),
        credentials: 'same-origin'
      }).catch(function () {});
    }

    // Error & add-to-cart state
    if (selections.length === MAX) {
      errorEl.textContent = '';
      enableAddToCart();
    } else {
      disableAddToCart();
      if (selections.length > 0 && selections.length < MAX) {
        errorEl.textContent = 'Pick ' + (MAX - selections.length) + ' more flavour' + (MAX - selections.length > 1 ? 's' : '') + '.';
      } else {
        errorEl.textContent = '';
      }
    }
  }

  function disableAddToCart() {
    if (addToCartBtn) {
      addToCartBtn.disabled = true;
      addToCartBtn.setAttribute('title', 'Please select 3 cocktails first');
    }
  }

  function enableAddToCart() {
    if (addToCartBtn) {
      addToCartBtn.disabled = false;
      addToCartBtn.removeAttribute('title');
    }
  }

  /* ── Click handler ───────────────────────────────────────── */

  function handleFlavourClick(e) {
    var btn = e.target.closest('.sk-flavour');
    if (!btn) return;

    var flavour = btn.getAttribute('data-flavour');

    if (selections.length < MAX) {
      // Add selection
      selections.push(flavour);
    } else {
      // Already at max — if clicking a selected one, remove one instance
      var idx = selections.indexOf(flavour);
      if (idx !== -1) {
        selections.splice(idx, 1);
      }
      // If clicking an unselected one at max, do nothing (show hint)
    }

    updateUI();
  }

  /* ── Long-press / right-click to remove ──────────────────── */

  function handleRemove(e) {
    var btn = e.target.closest('.sk-flavour');
    if (!btn) return;

    var flavour = btn.getAttribute('data-flavour');
    var idx = selections.indexOf(flavour);
    if (idx !== -1) {
      e.preventDefault();
      selections.splice(idx, 1);
      updateUI();
    }
  }

  /* ── Init ────────────────────────────────────────────────── */

  function init() {
    picker = document.getElementById('sk-picker');
    if (!picker) return;

    grid = document.getElementById('sk-grid');
    counter = document.getElementById('sk-counter');
    countEl = document.getElementById('sk-count');
    errorEl = document.getElementById('sk-error');
    prop1 = document.getElementById('sk-prop-1');
    prop2 = document.getElementById('sk-prop-2');
    prop3 = document.getElementById('sk-prop-3');
    propTags = document.getElementById('sk-prop-tags');

    // Find the add-to-cart button in the same product form
    var form = picker.closest('form') || document.querySelector('product-form-component form');
    if (form) {
      addToCartBtn = form.querySelector('[name="add"], [ref="addToCartButton"]');
    }
    if (!addToCartBtn) {
      addToCartBtn = document.querySelector('[ref="addToCartButton"]');
    }

    picker.style.display = '';
    disableAddToCart();

    grid.addEventListener('click', handleFlavourClick);
    grid.addEventListener('contextmenu', handleRemove);

    // Intercept form submission to validate
    if (form) {
      form.addEventListener('submit', function (e) {
        if (selections.length !== MAX) {
          e.preventDefault();
          e.stopPropagation();
          errorEl.textContent = 'Please select exactly 3 cocktails before adding to cart.';
          grid.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return false;
        }
      }, true); // capture phase
    }

    updateUI();
  }

  /* ── Boot ────────────────────────────────────────────────── */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

  new MutationObserver(function () {
    var el = document.getElementById('sk-picker');
    if (el && !el.__skBound) { el.__skBound = true; init(); }
  }).observe(document.body, { childList: true, subtree: true });

})();
